import React, { FC, useState } from "react";
import { RecommendationDto } from "@green0meter/api-client";

import Pagination from "./components/Pagination";
import { Item } from "./components";

import { Grid } from "@components/base";
import { getRecommendationLanguage } from "@components/main/recommendation/Recommendations.helpers";

interface Component {
  recommendations: RecommendationDto[];
}

const Component: FC<Component> = ({ recommendations }) => {
  const [page, setPage] = useState(0);
  const perPage = 6;
  const pages = Math.ceil(recommendations.length / perPage);
  const showPagination = pages > 1;

  return (
    <Grid container spacing={3}>
      {recommendations
        .slice(page * perPage, page * perPage + perPage)
        .map((recommendation) => {
          const translation = recommendation.translations.find(
            (t) => t.languages_code === getRecommendationLanguage(),
          );

          return translation ? (
            <Grid size={{ lg: 4, md: 6, sm: 12 }} key={recommendation.external_id}>
              <Item translation={translation} recommendation={recommendation} />
            </Grid>
          ) : null;
        })}
      {showPagination && (
        <Grid size={12}>
          <Pagination page={page} setPage={setPage} pages={pages} />
        </Grid>
      )}
    </Grid>
  );
};

export default Component;
